export default __webpack_public_path__ + "static/media/self_ru.59e61ccf.svg";